/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/blank_canvas_template" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { BlankCanvasTemplateCacheKeys } from "./constants";
import type { BlankCanvasTemplateProps, BlankCanvasTemplateResult } from "./types";

export const postBlankCanvasTemplate = reactQueryMutationAdapter(
  BlankCanvasTemplateCacheKeys,
  (props: BlankCanvasTemplateProps): Promise<BlankCanvasTemplateResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/structural_template/blank_canvas_template`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
